// extracted by mini-css-extract-plugin
module.exports = {"module":"FooterActions_module__xjDhi","localeSwitcher":"FooterActions_localeSwitcher__2OYYj"};